import React, { useState } from 'react';
export const QualifikationenPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'berufserfahrung' | 'weiterbildung'>('berufserfahrung');
  return <section className="w-full bg-white py-16 px-6 md:px-12 lg:px-20" data-id="element-666">
      <div className="max-w-6xl mx-auto" data-id="element-667">
        <h1 className="text-3xl md:text-4xl text-orange-500 font-light mb-8" data-id="element-668">
          Qualifikationen
        </h1>

        <h2 className="text-2xl md:text-3xl text-gray-700 font-light mb-12" data-id="element-669">
          Fundiert und vielfältig.
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-670">
          <div data-id="element-671">
            {/* Tab Navigation */}
            <div className="flex mb-8" data-id="element-672">
              <button onClick={() => setActiveTab('berufserfahrung')} className={`px-8 py-4 text-lg font-normal transition-colors relative ${activeTab === 'berufserfahrung' ? 'bg-orange-500 text-white' : 'bg-orange-400 text-white hover:bg-orange-500'}`} data-id="element-673">
                Qualifikationen
                {activeTab === 'berufserfahrung' && <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-full w-0 h-0 border-l-[12px] border-l-transparent border-r-[12px] border-r-transparent border-t-[12px] border-t-orange-500" data-id="element-674"></div>}
              </button>
              <button onClick={() => setActiveTab('weiterbildung')} className={`px-8 py-4 text-lg font-normal transition-colors relative ${activeTab === 'weiterbildung' ? 'bg-orange-500 text-white' : 'bg-orange-400 text-white hover:bg-orange-500'}`} data-id="element-675">
                Weiterbildung
                {activeTab === 'weiterbildung' && <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-full w-0 h-0 border-l-[12px] border-l-transparent border-r-[12px] border-r-transparent border-t-[12px] border-t-orange-500" data-id="element-676"></div>}
              </button>
            </div>

            {/* Tab Content */}
            <div className="mt-8" data-id="element-677">
              {activeTab === 'berufserfahrung' && <ul className="space-y-4 text-gray-700" data-id="element-678">
                  <li className="flex items-start" data-id="element-679">
                    <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-gray-700 rounded-full flex-shrink-0" data-id="element-680"></span>
                    <span data-id="element-681">
                      Studium der Psychologie an der Universität Heidelberg und
                      an der State University of New York
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-682">
                    <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-gray-700 rounded-full flex-shrink-0" data-id="element-683"></span>
                    <span data-id="element-684">
                      Berufseinstieg an der Universität Heidelberg als
                      wissenschaftliche Mitarbeiterin an der Psychiatrischen
                      Universitätsklinik, gefördert mit einem Stipendium der
                      Deutschen Forschungsgemeinschaft (DFG)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-685">
                    <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-gray-700 rounded-full flex-shrink-0" data-id="element-686"></span>
                    <span data-id="element-687">
                      Beraterin und Trainerin für Management Diagnostik der
                      Volkswagen Coaching GmbH & Senior Consultant bei
                      Mühlenhoff Management Beratung für Outplacement und
                      Executive Coaching
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-688">
                    <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-gray-700 rounded-full flex-shrink-0" data-id="element-689"></span>
                    <span data-id="element-690">
                      HR Manager bei T-Systems, HR Director BearingPoint
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-691">
                    <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-gray-700 rounded-full flex-shrink-0" data-id="element-692"></span>
                    <span data-id="element-693">Inhaberin wandelwert</span>
                  </li>
                  <li className="flex items-start" data-id="element-694">
                    <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-gray-700 rounded-full flex-shrink-0" data-id="element-695"></span>
                    <span data-id="element-696">
                      Gründung{' '}
                      <a href="https://praxis-schifferer-sturny.com/" target="_blank" rel="noopener noreferrer" className="text-orange-500 hover:text-orange-600 underline transition-colors" data-id="element-697">
                        Psychologische Praxis
                      </a>
                    </span>
                  </li>
                </ul>}

              {activeTab === 'weiterbildung' && <ul className="space-y-4 text-gray-700" data-id="element-698">
                  <li className="flex items-start" data-id="element-699">
                    <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-gray-700 rounded-full flex-shrink-0" data-id="element-700"></span>
                    <span data-id="element-701">
                      Zertifizierung als systemischer Coach an der European
                      Business School Oestrich-Winkel (EBS)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-702">
                    <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-gray-700 rounded-full flex-shrink-0" data-id="element-703"></span>
                    <span data-id="element-704">
                      Ausbildung zur Change Managerin, Henley Business School,
                      University of Reading, UK
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-705">
                    <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-gray-700 rounded-full flex-shrink-0" data-id="element-706"></span>
                    <span data-id="element-707">
                      Systemische Beratung am Institut für Systemische Beratung
                      in Wiesloch (ISBW)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-708">
                    <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-gray-700 rounded-full flex-shrink-0" data-id="element-709"></span>
                    <span data-id="element-710">
                      Weiterbildung in Verhaltenstherapie, Gesellschaft für
                      Ausbildung in Psychotherapie in Frankfurt
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-711">
                    <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-gray-700 rounded-full flex-shrink-0" data-id="element-712"></span>
                    <span data-id="element-713">
                      Zertifizierungen in Hogan Assessments, Agile Leader
                      Assessment, Facet 5, XLNC Leadership Diagnostik, Denison
                      Kulturanalyse und Lumina Spark
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-714">
                    <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-gray-700 rounded-full flex-shrink-0" data-id="element-715"></span>
                    <span data-id="element-716">Agile Methoden, The People Network</span>
                  </li>
                  <li className="flex items-start" data-id="element-717">
                    <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-gray-700 rounded-full flex-shrink-0" data-id="element-718"></span>
                    <span data-id="element-719">
                      Mitglied im Berufsverband Deutscher Psychologinnen und
                      Psychologen (BDP) sowie im Verband freier
                      Psychotherapeuten (VFP)
                    </span>
                  </li>
                </ul>}
            </div>
          </div>

          <div className="flex justify-center items-center" data-id="element-720">
            <img src="https://cdn.magicpatterns.com/uploads/rWQ6VLgm4NNRFuCaFRgXki/Eva-Schifferer-Coaching-Buecher.png" alt="Bücherstapel" className="max-h-96 object-contain" data-id="element-721" />
          </div>
        </div>
      </div>
    </section>;
};